var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 147,
    viewBox: "0 0 170 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6985 91.9578L60.3841 76.0811L80.6252 60.47L81.3058 78.0524L58.6985 91.9578Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.19 23.7761L65.9435 33.2387L81.5534 58.1779L61.6395 49.8418L48.19 23.7761Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40139 86.892L25.1138 81.8602L55.3964 90.397L38.787 97.8177L8.40139 86.892Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1507 57.8241L28.8631 52.7923L59.1457 61.3291L42.5362 68.7498L12.1507 57.8241Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2493 106.337L68.4633 95.9908L98.0526 95.0821L86.9361 107.81L56.2493 106.337Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.822 101.911L125.387 86.0036L145.485 70.2595L146.295 87.8613L123.822 101.911Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.434 103.906L101.748 92.809L89.5409 67.0082L108.595 77.2563L118.434 103.906Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2218 35.0352L93.2468 36.0498L120.18 52.9946L100.238 54.0568L74.2218 35.0352Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5723 62.6889L108.863 56.9868L139.273 64.454L123.205 72.5607L92.5723 62.6889Z",
    fill: "#6957BA",
    stroke: "#6957BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnA);
export default __webpack_public_path__ + "static/media/btn-a.1d5dd08e94aa95c747faf3b1f565ce25.svg";
export { ForwardRef as ReactComponent };